module.exports = __webpack_public_path__ + "img/icon_kor.9ad66a6.png";